export const getMatchConfidence = (topScore: number, score: number) => {
  if (score >= topScore * 0.95) {
    return 'high';
  } else if (score >= topScore * 0.8) {
    return 'medium';
  } else {
    return 'low';
  }
};
